module.exports = __webpack_public_path__ + "img/catC.aa8a8276.svg";